import { UserInfoService } from './../../../shared-resources/services/user-info.service';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LogoutService } from '../../services/logout.service';
import { LoginService } from '../../services/login.service';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { UserResponse } from 'src/app/shared-resources/interfaces/base-core-services.interface';

@Component({
  selector: 'header-user',
  template: `
    <div nz-dropdown [nzDropdownMenu]="menu" class="hand">
      
      <nz-avatar
        *ngIf="photo.title === 'Loading' || photo.title === 'Upload'"
        nzSrc="./assets/img/avatar.png"
        nzSize="small"
        class="mr-sm"
        nz-tooltip
        [nzTooltipTitle]="userInfo?.firstName"
        nzTooltipPlacement="bottomLeft"
        [nzTooltipArrowPointAtCenter]="true"
      ></nz-avatar>
      <nz-avatar
        *ngIf="photo.title === 'Change'"
        [nzSrc]="photo.image"
        nzSize="small"
        class="mr-sm"
        nz-tooltip
        [nzTooltipTitle]="userInfo?.firstName"
        nzTooltipPlacement="bottomLeft"
        [nzTooltipArrowPointAtCenter]="true"
      ></nz-avatar>
    </div>
    <nz-dropdown-menu #menu="nzDropdownMenu">
      <ul nz-menu nzSelectable>
        
        <li nz-menu-item (click)="logout()">
          <i nz-icon nzType="logout" class="mr-sm"></i>
          {{ 'menu.account.logout' | translate }}
        </li>
      </ul>
    </nz-dropdown-menu>
  `,
  styles: [
    ':host ::ng-deep{.alain-default__nav{padding-right:10px}} .hand{cursor: pointer;}',
  ],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class HeaderUserComponent implements OnInit {
  userInfo: UserResponse | undefined;
  token: any;
  userName: any;
  photo = {
    image: '',
    title: 'Loading',
    loading: false,
  };

  constructor(
    private router: Router,
    public userService: UserInfoService,
    public logoutService: LogoutService,
    public loginService: LoginService,
    public sanitizer: DomSanitizer,
    public translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.getUserData();
    this.userService.getUserInfo$().subscribe(() => {
      this.getUserData();
    });
  }

  getUserData() {
    this.userInfo = this.userService.getUserInfo();
    this.token = this.userService.getUserToken();
    this.userName = this.userService.getUserName();
    this.setProfilePic();
  }

  logout() {
    const formBody = {
      token: this.token,
      userName: this.userName,
    };
    this.logoutService.showLogoutModal(
      this.translate.instant('menu.account.logout'),
      this.translate.instant('app.label.logout.all.device'),
      formBody
    );
  }
  userProfile() {
    this.router.navigateByUrl('/app/settings');
  }
  setProfilePic() {
    if (this.userInfo && this.userInfo.photoPath) {
      this.photo.loading = true;
      this.loginService.getUserProfilePic(this.userInfo.photoPath).subscribe(
        (res: Blob | MediaSource) => {
          const unsafeImageUrl = URL.createObjectURL(res);
          this.photo.image = String(
            this.sanitizer.bypassSecurityTrustUrl(unsafeImageUrl)
          );
          this.photo.title = 'Change';
          this.photo.loading = false;
        },
        () => {
          this.photo.loading = false;
        }
      );
    } else {
      this.photo.title = 'Upload';
    }
  }
}
